import * as React from "react";
import { useTranslation } from "react-i18next";
import DefinitionList from "components/common/DefinitionList";
import ChipsCell from "components/common/ChipsCell";
import useAppendTagFilter from "components/events/useAppendTagFilter";
const TagsDetailRow = ({ tags, interactive = true }) => {
  const { t } = useTranslation("events");
  const onTagClick = useAppendTagFilter();
  if (!(tags == null ? void 0 : tags.length)) return null;
  return /* @__PURE__ */ React.createElement(DefinitionList, null, /* @__PURE__ */ React.createElement("dt", null, t("alerts_attributes.tags")), /* @__PURE__ */ React.createElement("dd", null, interactive ? /* @__PURE__ */ React.createElement(ChipsCell, { items: tags, truncate: false, onItemClick: onTagClick, itemLabel: "tag" }) : /* @__PURE__ */ React.createElement(ChipsCell, { items: tags, truncate: false })));
};
export default TagsDetailRow;
